import Module from '../module.js';
import {Reveal, Typography, Cursor} from '../../animations';
import Toggle from '../../toggle/toggle.js';
import { SCROLL } from '../../app.config.js'
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

//css
import '../../../scss/components/_card-h-sm.scss';
import '../../../scss/components/_filters.scss';
import '../../../scss/components/_tag.scss';
import '../../../scss/components/_pagination.scss';
import './news-index.scss';

export class NewsIndexModule extends Module {

  constructor(el) {
    super(el);
  }

  init() {
    this.reveal = new Reveal(this.node);
    Typography.split(this.node);
    this.typography = new Typography(this.node);
    this.cursor = Cursor.init(this.node);
    this.initFilters();
    this.initPanel();
    this.ready();
  }

  destroy() {
    Cursor.destroyAll();
    this.destroyed();
  }

  // FILTERS
  initFilters() {
    this.toggleFilters = Toggle.init(
      '[data-filter-btn]',
      '[data-filter-target]',
      this.node,
      'active',
      this.onToggleFilters.bind(this)
    );
  }

  onToggleFilters({ item }) {
    const panel = item.target;
    const filters = this.node.querySelector('[data-filters]')
    item.node.classList.toggle('active');
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      filters.style.paddingBottom = null;
    } else {
      this.resetMaxHeights();
      panel.style.maxHeight = panel.scrollHeight + "px";
      filters.style.paddingBottom = panel.scrollHeight + "px";
    }
  }

  resetMaxHeights() {
    const panels = Array.from(this.node.querySelectorAll('[data-filter-target]'));
    panels.forEach(panel => panel.style.maxHeight = null);
  }

  // MOBILE/TABLET PANEL
  initPanel() {
    this.togglePanel = Toggle.init(
      '[data-filters-panel-btn]',
      '[data-filters-panel-target]',
      this.node,
      'active',
      this.onTogglePanel.bind(this)
    )
  }

  onTogglePanel({ item }) {
    const scrollBlocker = this.node.querySelector('.scroll-blocker');
    if(document.body.classList.contains('_filters-panel')) {
      document.body.classList.remove('_filters-panel')
      scrollBlocker.classList.remove('_dark');
      SCROLL && window.client.scroller.start();
      ScrollTrigger.normalizeScroll(true)
    } else {
      document.body.classList.add('_filters-panel')
      scrollBlocker.classList.add('_dark');
      SCROLL && window.client.scroller.stop();
      ScrollTrigger.normalizeScroll(false)
    }
  }
}

export function createInstance() {
  const instance = new NewsIndexModule();
  return instance;
}
